export default __webpack_public_path__ + "banner-image.png";